module.exports = __webpack_public_path__ + "img/document-black-icon.4dde4aea.svg";